import { ChangeDetectionStrategy, Component, ElementRef, afterNextRender, input, output, viewChild } from '@angular/core';

export type MaintenanceDayItem = {
  key: string;
  installation: string;
  intervenant: string;
  horaire: string;
  color: string;
};

@Component({
  selector: 'app-maintenance-day-panel',
  templateUrl: './maintenance-day-panel.html',
  styleUrl: './maintenance-day-panel.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceDayPanel {
  readonly dateLabel = input.required<string>();
  readonly interventions = input.required<MaintenanceDayItem[]>();
  readonly fermer = output<void>();
  readonly ouvrirIntervention = output<string>();
  private readonly fermerBouton = viewChild<ElementRef<HTMLButtonElement>>('fermerBouton');

  constructor() {
    afterNextRender(() => this.fermerBouton()?.nativeElement.focus());
  }
}
